import React from 'react'
import { ShoppingCartIcon } from '@heroicons/react/24/outline'

const Total = ({ urlCursos, send, data, guardarCursosSeleccionados, opcion = 0 }) => { //(project.Seleccionado || project.Cobrado)
  return (
    <div className={"flex flex-col"}>
      <hr></hr>
      <div className=' text-2xl font-medium flex flex-row justify-between px-4 m-2'>
        <p className='text-white inline'>Total:</p>
        <p className='text-secundario inline'>
          {opcion !== 3
            ? Intl.NumberFormat("es-GT", {
              style: "currency",
              currency: "GTQ",
            }).format(data.filter(elemento => (elemento.Seleccionado && elemento.Pagar) && !elemento?.Cobrado).reduce((anterior, actual) => anterior + actual.Valor, 0) | 0)
            : Intl.NumberFormat("es-GT", {
              style: "currency",
              currency: "GTQ",
            }).format(data.filter(elemento => elemento?.Cobrado).reduce((anterior, actual) => anterior + actual.Valor, 0) | 0)
          }
        </p>
      </div>
      {opcion !== 3
        ? data.filter(cargo => (cargo.Seleccionado && cargo.Pagar) && !cargo?.Cobrado).length > 0 &&  // Pagar
        <button
          onClick={() => data.length > 0 && guardarCursosSeleccionados()}
          className={'bg-azulBrillanteMira text-white p-2 rounded-md font-medium hover:shadow-sm hover:shadow-white'}
        >
          {`(${data.filter(cargo => (cargo.Seleccionado && cargo.Pagar) && !cargo?.Cobrado).length})`}<ShoppingCartIcon className='h-6 w-6  mr-2 inline'></ShoppingCartIcon>
          {opcion === 0
            ? 'Completar pago'
            : opcion === 1
              ? 'Aplicar cambio de horario y completar pago'
              : opcion === 2
                ? 'Aplicar traslado de fondos'
                : 'Aplicar devolución'
          }
        </button>
        : data.filter(cargo => cargo?.Cobrado).length > 0 &&  // Pagar
        <button
          onClick={() => data.length > 0 && guardarCursosSeleccionados()}
          className={'bg-azulBrillanteMira text-white p-2 rounded-md font-medium hover:shadow-sm hover:shadow-white'}
        >
          {`(${data.filter(cargo => cargo?.Cobrado).length})`}<ShoppingCartIcon className='h-6 w-6  mr-2 inline'></ShoppingCartIcon>
          {opcion === 0
            ? 'Completar pago'
            : opcion === 1
              ? 'Aplicar cambio de horario y completar pago'
              : opcion === 2
                ? 'Aplicar traslado de fondos'
                : 'Aplicar devolución'
          }
        </button>
      }
    </div>
  )
}

export default Total